var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategoryPancakes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_5390)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_465_5390)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_465_5390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.2545 130.483C56.658 130.483 39.5916 128.649 26.2236 125.593C28.1469 130.658 31.7601 134.488 36.2154 135.714C46.2707 138.481 60.051 140.188 75.2545 140.188C90.458 140.188 104.238 138.481 114.294 135.714C118.749 134.488 122.362 130.658 124.285 125.593C110.917 128.649 93.851 130.483 75.2545 130.483Z",
    fill: "url(#paint0_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.254 116.119C150.254 141.831 0.254395 141.831 0.254395 116.119C0.254395 90.4065 150.254 90.4065 150.254 116.119Z",
    fill: "url(#paint1_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.96 114.233C139.96 132.565 10.5485 132.565 10.5485 114.233C10.5485 95.9016 139.96 95.9016 139.96 114.233Z",
    fill: "url(#paint2_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.254 116.119C150.254 95.81 56.6774 91.5424 17.3456 103.315C17.4459 103.432 17.5468 103.549 17.6556 103.663C15.5953 105.291 14.4495 107.113 14.4495 109.131C14.4495 111.018 15.4506 112.733 17.2633 114.279L35.783 132.799C80.1392 139.258 150.254 133.699 150.254 116.119Z",
    fill: "url(#paint3_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.06 109.131C136.06 129.977 14.4504 129.977 14.4504 109.131C14.4504 88.2854 136.06 88.2854 136.06 109.131Z",
    fill: "url(#paint4_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M116.391 104.749C117.502 104.749 118.401 103.639 118.401 102.27C118.401 100.901 117.502 99.7909 116.391 99.7909C115.281 99.7909 114.381 100.901 114.381 102.27C114.381 103.639 115.281 104.749 116.391 104.749Z",
    fill: "url(#paint5_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M112.66 110.639C113.536 110.639 114.246 109.762 114.246 108.681C114.246 107.6 113.536 106.724 112.66 106.724C111.783 106.724 111.073 107.6 111.073 108.681C111.073 109.762 111.783 110.639 112.66 110.639Z",
    fill: "url(#paint6_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.576 111.504C120.104 111.504 120.533 110.975 120.533 110.324C120.533 109.672 120.104 109.144 119.576 109.144C119.048 109.144 118.619 109.672 118.619 110.324C118.619 110.975 119.048 111.504 119.576 111.504Z",
    fill: "url(#paint7_linear_465_5390)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M127.019 105.971C127.84 105.971 128.505 105.15 128.505 104.139C128.505 103.127 127.84 102.307 127.019 102.307C126.199 102.307 125.534 103.127 125.534 104.139C125.534 105.15 126.199 105.971 127.019 105.971Z",
    fill: "url(#paint8_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M122.318 106.208C122.966 106.208 123.491 105.561 123.491 104.762C123.491 103.963 122.966 103.316 122.318 103.316C121.67 103.316 121.145 103.963 121.145 104.762C121.145 105.561 121.67 106.208 122.318 106.208Z",
    fill: "url(#paint9_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M124.993 111.142C125.383 111.142 125.699 110.751 125.699 110.27C125.699 109.788 125.383 109.397 124.993 109.397C124.602 109.397 124.286 109.788 124.286 110.27C124.286 110.751 124.602 111.142 124.993 111.142Z",
    fill: "url(#paint10_linear_465_5390)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.059 109.131C136.059 104.349 129.655 100.664 119.79 98.0759H30.7186C20.8536 100.664 14.4495 104.349 14.4495 109.131C14.4498 129.977 136.059 129.977 136.059 109.131Z",
    fill: "url(#paint11_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.06 98.0763C136.06 118.922 14.4504 118.922 14.4504 98.0763C14.4504 77.2304 136.06 77.2304 136.06 98.0763Z",
    fill: "url(#paint12_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.059 98.0763C136.059 93.2936 129.655 89.6092 119.79 87.021H30.7186C20.8536 89.6089 14.4495 93.2936 14.4495 98.076C14.4498 118.922 136.059 118.922 136.059 98.0763Z",
    fill: "url(#paint13_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M35.6812 101.958C36.7913 101.958 37.6912 101.096 37.6912 100.033C37.6912 98.969 36.7913 98.1069 35.6812 98.1069C34.5711 98.1069 33.6712 98.969 33.6712 100.033C33.6712 101.096 34.5711 101.958 35.6812 101.958Z",
    fill: "url(#paint14_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M31.949 106.532C32.8254 106.532 33.5358 105.851 33.5358 105.012C33.5358 104.172 32.8254 103.492 31.949 103.492C31.0727 103.492 30.3622 104.172 30.3622 105.012C30.3622 105.851 31.0727 106.532 31.949 106.532Z",
    fill: "url(#paint15_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M38.8656 107.204C39.3941 107.204 39.8224 106.794 39.8224 106.288C39.8224 105.781 39.3941 105.371 38.8656 105.371C38.3372 105.371 37.9089 105.781 37.9089 106.288C37.9089 106.794 38.3372 107.204 38.8656 107.204Z",
    fill: "url(#paint16_linear_465_5390)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M46.3087 102.907C47.129 102.907 47.794 102.27 47.794 101.484C47.794 100.698 47.129 100.061 46.3087 100.061C45.4884 100.061 44.8234 100.698 44.8234 101.484C44.8234 102.27 45.4884 102.907 46.3087 102.907Z",
    fill: "url(#paint17_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M41.6075 103.091C42.2552 103.091 42.7802 102.588 42.7802 101.968C42.7802 101.347 42.2552 100.845 41.6075 100.845C40.9599 100.845 40.4349 101.347 40.4349 101.968C40.4349 102.588 40.9599 103.091 41.6075 103.091Z",
    fill: "url(#paint18_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M44.282 106.923C44.6724 106.923 44.9888 106.619 44.9888 106.246C44.9888 105.872 44.6724 105.568 44.282 105.568C43.8917 105.568 43.5753 105.872 43.5753 106.246C43.5753 106.619 43.8917 106.923 44.282 106.923Z",
    fill: "url(#paint19_linear_465_5390)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.06 87.0209C136.06 107.867 14.4504 107.867 14.4504 87.0209C14.4504 66.175 136.06 66.175 136.06 87.0209Z",
    fill: "url(#paint20_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.059 87.0209C136.059 82.2382 129.655 78.5538 119.79 75.9656H30.7186C20.8536 78.5535 14.4495 82.2382 14.4495 87.0206C14.4498 107.867 136.059 107.867 136.059 87.0209Z",
    fill: "url(#paint21_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M78.6979 94.2512C79.808 94.2512 80.7079 93.3891 80.7079 92.3256C80.7079 91.2621 79.808 90.4 78.6979 90.4C77.5878 90.4 76.6879 91.2621 76.6879 92.3256C76.6879 93.3891 77.5878 94.2512 78.6979 94.2512Z",
    fill: "url(#paint22_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M74.9658 98.8247C75.8421 98.8247 76.5526 98.1441 76.5526 97.3047C76.5526 96.4652 75.8421 95.7847 74.9658 95.7847C74.0894 95.7847 73.379 96.4652 73.379 97.3047C73.379 98.1441 74.0894 98.8247 74.9658 98.8247Z",
    fill: "url(#paint23_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M81.8825 99.4968C82.4109 99.4968 82.8392 99.0864 82.8392 98.5803C82.8392 98.0741 82.4109 97.6638 81.8825 97.6638C81.3541 97.6638 80.9257 98.0741 80.9257 98.5803C80.9257 99.0864 81.3541 99.4968 81.8825 99.4968Z",
    fill: "url(#paint24_linear_465_5390)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.06 75.966C136.06 96.8118 14.4504 96.8118 14.4504 75.966C14.4504 55.1201 136.06 55.1201 136.06 75.966Z",
    fill: "url(#paint25_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.059 75.9659C136.059 71.1833 129.655 67.4989 119.79 64.9106H30.7186C20.8536 67.4986 14.4495 71.1833 14.4495 75.9656C14.4498 96.8118 136.059 96.8118 136.059 75.9659Z",
    fill: "url(#paint26_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M127.019 73.6759C127.84 73.6759 128.505 72.9847 128.505 72.1321C128.505 71.2794 127.84 70.5883 127.019 70.5883C126.199 70.5883 125.534 71.2794 125.534 72.1321C125.534 72.9847 126.199 73.6759 127.019 73.6759Z",
    fill: "url(#paint27_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M122.318 73.8759C122.966 73.8759 123.491 73.3303 123.491 72.6574C123.491 71.9844 122.966 71.4388 122.318 71.4388C121.67 71.4388 121.145 71.9844 121.145 72.6574C121.145 73.3303 121.67 73.8759 122.318 73.8759Z",
    fill: "url(#paint28_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M124.993 78.0329C125.383 78.0329 125.699 77.7039 125.699 77.2982C125.699 76.8924 125.383 76.5635 124.993 76.5635C124.602 76.5635 124.286 76.8924 124.286 77.2982C124.286 77.7039 124.602 78.0329 124.993 78.0329Z",
    fill: "url(#paint29_linear_465_5390)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.06 64.9105C136.06 85.7564 14.4504 85.7564 14.4504 64.9105C14.4504 44.0647 136.06 44.0647 136.06 64.9105Z",
    fill: "url(#paint30_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.059 64.9105C136.059 60.1279 129.655 56.4435 119.79 53.8552H30.7186C20.8536 56.4432 14.4495 60.1279 14.4495 64.9102C14.4498 85.7564 136.059 85.7564 136.059 64.9105Z",
    fill: "url(#paint31_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.06 53.8556C136.06 74.7015 14.4504 74.7015 14.4504 53.8556C14.4504 33.0097 136.06 33.0094 136.06 53.8556Z",
    fill: "url(#paint32_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M116.391 49.4731C117.502 49.4731 118.401 48.3632 118.401 46.994C118.401 45.6248 117.502 44.5149 116.391 44.5149C115.281 44.5149 114.381 45.6248 114.381 46.994C114.381 48.3632 115.281 49.4731 116.391 49.4731Z",
    fill: "url(#paint33_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M112.66 55.3625C113.536 55.3625 114.246 54.4861 114.246 53.4051C114.246 52.3241 113.536 51.4478 112.66 51.4478C111.783 51.4478 111.073 52.3241 111.073 53.4051C111.073 54.4861 111.783 55.3625 112.66 55.3625Z",
    fill: "url(#paint34_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.576 56.2277C120.104 56.2277 120.533 55.6994 120.533 55.0477C120.533 54.396 120.104 53.8677 119.576 53.8677C119.048 53.8677 118.619 54.396 118.619 55.0477C118.619 55.6994 119.048 56.2277 119.576 56.2277Z",
    fill: "url(#paint35_linear_465_5390)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M127.019 50.6945C127.84 50.6945 128.505 49.8743 128.505 48.8625C128.505 47.8506 127.84 47.0304 127.019 47.0304C126.199 47.0304 125.534 47.8506 125.534 48.8625C125.534 49.8743 126.199 50.6945 127.019 50.6945Z",
    fill: "url(#paint36_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M122.318 50.932C122.966 50.932 123.491 50.2846 123.491 49.4859C123.491 48.6872 122.966 48.0397 122.318 48.0397C121.67 48.0397 121.145 48.6872 121.145 49.4859C121.145 50.2846 121.67 50.932 122.318 50.932Z",
    fill: "url(#paint37_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M124.993 55.8653C125.383 55.8653 125.699 55.4749 125.699 54.9933C125.699 54.5116 125.383 54.1212 124.993 54.1212C124.602 54.1212 124.286 54.5116 124.286 54.9933C124.286 55.4749 124.602 55.8653 124.993 55.8653Z",
    fill: "url(#paint38_linear_465_5390)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.059 53.8556C136.059 49.0729 129.655 45.3885 119.79 42.8003H30.7186C20.8536 45.3882 14.4495 49.0729 14.4495 53.8553C14.4498 74.7015 136.059 74.7015 136.059 53.8556Z",
    fill: "url(#paint39_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.059 109.131C136.059 107.088 134.887 105.246 132.779 103.604C134.886 101.961 136.059 100.119 136.059 98.0759C136.059 96.0326 134.887 94.1909 132.779 92.5485C134.886 90.9059 136.059 89.0641 136.059 87.0209C136.059 84.9776 134.887 83.1359 132.779 81.4935C134.886 79.8509 136.059 78.0091 136.059 75.9659C136.059 73.9229 134.887 72.0809 132.779 70.4385C134.886 68.7959 136.059 66.9541 136.059 64.9109C136.059 62.8676 134.887 61.0259 132.779 59.3835C134.886 57.7409 136.059 55.8991 136.059 53.8559C136.059 36.6679 53.386 33.6526 24.3719 44.8088V75.9118C24.3719 77.6965 25.2578 79.2715 26.6113 80.2306L71.1143 124.734C102.832 125.228 136.059 120.028 136.059 109.131Z",
    fill: "url(#paint40_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.059 53.8557C136.059 42.2169 98.152 37.0774 64.6661 38.4354V103.312C64.6661 105.076 65.5314 106.633 66.8564 107.595L83.8856 124.624C111.154 123.729 136.059 118.565 136.059 109.132C136.059 107.089 134.887 105.247 132.779 103.604C134.886 101.962 136.059 100.12 136.059 98.0766C136.059 96.0333 134.887 94.1916 132.779 92.5492C134.886 90.9066 136.059 89.0648 136.059 87.0216C136.059 84.9783 134.887 83.1366 132.779 81.4942C134.886 79.8516 136.059 78.0098 136.059 75.9666C136.059 73.9236 134.887 72.0816 132.779 70.4392C134.886 68.7966 136.059 66.9548 136.059 64.9116C136.059 62.8683 134.887 61.0266 132.779 59.3842C134.886 57.7407 136.059 55.8986 136.059 53.8557Z",
    fill: "url(#paint41_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.059 109.131C136.059 107.088 134.887 105.246 132.779 103.604C134.887 101.961 136.059 100.119 136.059 98.0759C136.059 96.0327 134.887 94.1909 132.779 92.5486C134.887 90.9059 136.059 89.0642 136.059 87.0209C136.059 84.9777 134.887 83.1359 132.779 81.4936C134.887 79.8509 136.059 78.0092 136.059 75.9659C136.059 73.923 134.887 72.0809 132.779 70.4386C134.887 68.7959 136.059 66.9542 136.059 64.9109C136.059 62.8677 134.887 61.0259 132.779 59.3836C134.887 57.7409 136.059 55.8992 136.059 53.8559C136.059 44.2159 110.055 39.0347 82.0957 38.3109V72.0059C82.0957 73.7042 82.8986 75.2118 84.1422 76.1806L126.14 118.178C132.314 115.804 136.059 112.789 136.059 109.131Z",
    fill: "url(#paint42_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.059 75.9657C136.059 73.9228 134.887 72.0807 132.779 70.4384C134.887 68.7957 136.059 66.954 136.059 64.9107C136.059 62.8675 134.887 61.0257 132.779 59.3834C134.887 57.7407 136.059 55.899 136.059 53.8557C136.059 48.6392 128.442 44.7292 117.024 42.1237V58.7666C117.024 60.3663 117.737 61.7969 118.858 62.7678L135.116 79.0257C135.731 78.061 136.059 77.0416 136.059 75.9657Z",
    fill: "url(#paint43_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.059 42.8004C136.059 21.9545 14.4498 21.9545 14.4498 42.8004C14.4498 45.821 17.0057 48.4034 21.3733 50.5484C23.1989 51.4448 24.3721 53.2843 24.3721 55.3184V75.9113C24.3721 78.8351 26.7424 81.2054 29.6662 81.2054C32.5901 81.2054 34.9604 78.8351 34.9604 75.9113V67.7728C34.9604 61.1713 40.7345 56.0672 47.2883 56.8598C49.6598 57.1466 52.1039 57.3943 54.6007 57.6028C60.2921 58.0781 64.6662 62.8457 64.6662 68.5572V103.313C64.6662 106.237 67.0365 108.607 69.9604 108.607C72.8842 108.607 75.2545 106.237 75.2545 103.313V70.3351C75.2545 68.4463 76.7857 66.9148 78.6748 66.9148C80.5636 66.9148 82.0951 68.446 82.0951 70.3351V72.0043C82.0951 74.9281 84.4654 77.2984 87.3892 77.2984C90.313 77.2984 92.6833 74.9281 92.6833 72.0043V69.7093C92.6833 63.1104 97.6083 57.5719 104.155 56.7451C107.224 56.3575 110.165 55.9034 112.934 55.3822C115.059 54.9822 117.024 56.6043 117.024 58.7666C117.024 61.6904 119.394 64.0607 122.318 64.0607C125.242 64.0607 127.612 61.6904 127.612 58.7666V58.7354C127.612 54.6416 129.571 50.836 132.797 48.3157C134.896 46.6766 136.059 44.8384 136.059 42.8004Z",
    fill: "url(#paint44_radial_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.06 42.7998C136.06 44.8381 134.895 46.6763 132.798 48.3175C129.572 50.8351 127.613 54.641 127.613 58.7351V58.7675C127.613 58.9322 127.604 59.0969 127.59 59.2586C127.475 60.5234 126.91 61.6616 126.063 62.5116C125.104 63.4704 123.781 64.0616 122.319 64.0616C120.854 64.0616 119.531 63.4704 118.575 62.5116C117.616 61.5528 117.025 60.2292 117.025 58.7675C117.025 56.6028 115.057 54.9822 112.934 55.3822C110.163 55.9028 107.225 56.3586 104.154 56.7439C100.107 57.2557 96.6778 59.5675 94.6514 62.8204L63.3102 31.4792C62.1984 30.5822 61.5661 29.4586 61.6455 28.0469C61.6543 27.8704 61.672 27.6939 61.6984 27.5204C73.1602 26.9145 85.2984 27.0881 96.369 28.0381C118.307 29.9145 136.06 34.8351 136.06 42.7998Z",
    fill: "url(#paint45_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4089 20.9957C70.5754 23.1622 70.5754 26.6745 68.4089 28.8407C66.2425 31.0072 62.7301 31.0072 60.5639 28.8407C58.3975 26.6742 55.2074 19.9719 57.3736 17.8054C59.5398 15.6389 66.2428 18.8295 68.4089 20.9957Z",
    fill: "url(#paint46_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3373 20.983C72.4346 24.4171 70.8511 27.2483 68.8002 27.3065C66.7493 27.3648 65.0076 24.628 64.9102 21.1936C64.8129 17.7592 66.2529 9.87093 68.3038 9.8127C70.3546 9.75476 72.2399 17.5486 72.3373 20.983Z",
    fill: "url(#paint47_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8602 15.6505C79.4802 15.6376 79.1002 15.6758 78.7313 15.7685C75.834 16.4946 62.0837 20.3417 61.6461 28.0476C61.3734 32.847 69.3022 34.3311 76.3793 34.704C82.8419 35.0446 88.4184 31.5996 88.7969 27.0438C89.2258 21.8835 87.9461 15.9276 79.8602 15.6505Z",
    fill: "url(#paint48_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8602 15.6505C79.4802 15.6376 79.1002 15.6758 78.7314 15.7685C75.834 16.4946 62.0837 20.3417 61.6461 28.0476C61.3734 32.847 69.3022 34.3311 76.3793 34.704C82.8417 35.0446 87.9461 15.9276 79.8602 15.6505Z",
    fill: "url(#paint49_linear_465_5390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1336 38.7544C15.0395 40.0024 14.4498 41.3509 14.4498 42.8003C14.4498 45.8209 17.0057 48.4033 21.373 50.5483C23.1986 51.4447 24.3721 53.2842 24.3721 55.3183V75.9112C24.3721 78.835 26.7424 81.2053 29.6662 81.2053C32.5901 81.2053 34.9604 78.835 34.9604 75.9112V67.7727C34.9604 61.1712 40.7345 56.0671 47.2883 56.8597C49.6598 57.1465 52.1039 57.3942 54.6007 57.6027C60.2921 58.078 64.6662 62.8456 64.6662 68.5571V103.313C64.6662 106.237 67.0365 108.607 69.9604 108.607C72.8842 108.607 75.2545 106.237 75.2545 103.313V70.335C75.2545 68.4462 76.7857 66.9147 78.6748 66.9147C80.5639 66.9147 82.0951 68.4459 82.0951 70.335V72.0042C82.0951 74.928 84.4654 77.2983 87.3892 77.2983C90.313 77.2983 92.6833 74.928 92.6833 72.0042V69.7092C92.6833 63.1103 97.6083 57.5718 104.155 56.745C107.224 56.3574 110.165 55.9033 112.934 55.3821C115.059 54.9821 117.024 56.6042 117.024 58.7665C117.024 61.6903 119.394 64.0606 122.318 64.0606C125.242 64.0606 127.612 61.6903 127.612 58.7665V58.7353C127.612 54.6415 129.571 50.8359 132.797 48.3156C134.896 46.6765 136.059 44.838 136.059 42.8C136.059 41.3506 135.469 40.0021 134.375 38.7542C120.827 54.2053 29.6815 54.2053 16.1336 38.7544Z",
    fill: "url(#paint50_linear_465_5390)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_5390",
    x1: 75.5339,
    y1: 130.202,
    x2: 76.1222,
    y2: 139.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_465_5390",
    x1: 70.327,
    y1: 97.5221,
    x2: 81.882,
    y2: 141.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_465_5390",
    x1: 78.4806,
    y1: 140.042,
    x2: 72.8923,
    y2: 95.3363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_465_5390",
    x1: 84.7115,
    y1: 130.358,
    x2: 75.888,
    y2: 63.8871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_465_5390",
    x1: 71.2604,
    y1: 94.0542,
    x2: 80.6284,
    y2: 129.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_465_5390",
    x1: 118.676,
    y1: 105.296,
    x2: 112.665,
    y2: 95.9161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_465_5390",
    x1: 114.535,
    y1: 111.076,
    x2: 109.79,
    y2: 103.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_465_5390",
    x1: 120.849,
    y1: 111.772,
    x2: 117.989,
    y2: 107.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_465_5390",
    x1: 126.508,
    y1: 106.793,
    x2: 128.801,
    y2: 98.5392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_465_5390",
    x1: 121.96,
    y1: 106.858,
    x2: 123.771,
    y2: 100.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_465_5390",
    x1: 124.868,
    y1: 111.535,
    x2: 125.959,
    y2: 107.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_465_5390",
    x1: 75.2545,
    y1: 118.824,
    x2: 75.2545,
    y2: 131.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F32816",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    stopColor: "#E3281D",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#CA2728",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_465_5390",
    x1: 71.2604,
    y1: 82.9992,
    x2: 80.6284,
    y2: 118.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_465_5390",
    x1: 75.2545,
    y1: 108.432,
    x2: 75.2545,
    y2: 119.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F32816",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    stopColor: "#E3281D",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#CA2728",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_465_5390",
    x1: 37.5932,
    y1: 102.551,
    x2: 32.6098,
    y2: 94.7739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_465_5390",
    x1: 33.5223,
    y1: 107.006,
    x2: 29.5879,
    y2: 100.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_465_5390",
    x1: 39.94,
    y1: 107.498,
    x2: 37.5679,
    y2: 103.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_465_5390",
    x1: 45.9287,
    y1: 103.592,
    x2: 47.7378,
    y2: 97.0808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_465_5390",
    x1: 41.3485,
    y1: 103.637,
    x2: 42.777,
    y2: 98.4962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_465_5390",
    x1: 44.207,
    y1: 107.258,
    x2: 45.0683,
    y2: 104.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_465_5390",
    x1: 71.2604,
    y1: 71.9438,
    x2: 80.6284,
    y2: 107.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_465_5390",
    x1: 75.2545,
    y1: 96.8626,
    x2: 75.2545,
    y2: 110.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F32816",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    stopColor: "#E3281D",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#CA2728",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_465_5390",
    x1: 80.6312,
    y1: 94.835,
    x2: 75.6478,
    y2: 87.0581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_465_5390",
    x1: 76.5604,
    y1: 99.2906,
    x2: 72.626,
    y2: 93.1511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_465_5390",
    x1: 82.9781,
    y1: 99.7819,
    x2: 80.6064,
    y2: 96.0806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_465_5390",
    x1: 71.2604,
    y1: 60.8889,
    x2: 80.6284,
    y2: 96.2451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_465_5390",
    x1: 75.2545,
    y1: 84.7059,
    x2: 75.2545,
    y2: 98.8292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F32816",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    stopColor: "#E3281D",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#CA2728",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_465_5390",
    x1: 126.611,
    y1: 74.3813,
    x2: 128.563,
    y2: 67.3582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_465_5390",
    x1: 122.041,
    y1: 74.4319,
    x2: 123.582,
    y2: 68.8876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_465_5390",
    x1: 124.914,
    y1: 78.3653,
    x2: 125.843,
    y2: 75.0227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_465_5390",
    x1: 71.2604,
    y1: 49.8335,
    x2: 80.6284,
    y2: 85.1897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_465_5390",
    x1: 75.2545,
    y1: 75.0979,
    x2: 75.2545,
    y2: 86.8632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F32816",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    stopColor: "#E3281D",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#CA2728",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_465_5390",
    x1: 71.2604,
    y1: 38.7782,
    x2: 80.6284,
    y2: 74.1347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_465_5390",
    x1: 118.67,
    y1: 49.9921,
    x2: 112.659,
    y2: 40.6116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_465_5390",
    x1: 114.529,
    y1: 55.7715,
    x2: 109.784,
    y2: 48.3664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_465_5390",
    x1: 120.843,
    y1: 56.4683,
    x2: 117.983,
    y2: 52.0038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_465_5390",
    x1: 126.497,
    y1: 51.5005,
    x2: 128.79,
    y2: 43.2469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_465_5390",
    x1: 121.95,
    y1: 51.566,
    x2: 123.76,
    y2: 45.0503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_465_5390",
    x1: 124.857,
    y1: 56.2425,
    x2: 125.949,
    y2: 52.3143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_465_5390",
    x1: 75.2545,
    y1: 61.9609,
    x2: 75.2545,
    y2: 77.4512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F32816",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    stopColor: "#E3281D",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#CA2728",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_465_5390",
    x1: 90.9516,
    y1: 78.0726,
    x2: 11.2548,
    y2: 16.7856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#F12817",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    stopColor: "#DD2820",
    stopOpacity: 0.611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_465_5390",
    x1: 111.523,
    y1: 87.8863,
    x2: 51.915,
    y2: 57.8863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#F12817",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    stopColor: "#DD2820",
    stopOpacity: 0.611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_465_5390",
    x1: 115.572,
    y1: 74.2997,
    x2: 68.5128,
    y2: 44.1036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#F12817",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    stopColor: "#DD2820",
    stopOpacity: 0.611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_465_5390",
    x1: 136.277,
    y1: 65.8031,
    x2: 118.433,
    y2: 49.2343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#F12817",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    stopColor: "#DD2820",
    stopOpacity: 0.611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_465_5390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.6662 27.0919) scale(77.6521 54.7447)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3126,
    stopColor: "#FFD643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5593,
    stopColor: "#FFCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7826,
    stopColor: "#FFBB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    stopColor: "#FFA426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_465_5390",
    x1: 103.948,
    y1: 46.4375,
    x2: 66.1046,
    y2: -35.7193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_465_5390",
    x1: 58.3183,
    y1: 24.7419,
    x2: 68.4191,
    y2: 22.0838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_465_5390",
    x1: 65.5942,
    y1: 16.1575,
    x2: 72.8823,
    y2: 18.4638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_465_5390",
    x1: 74.1178,
    y1: 22.4505,
    x2: 77.9087,
    y2: 34.1679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#FF8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#FF6C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_465_5390",
    x1: 73.4408,
    y1: 24.9279,
    x2: 87.6861,
    y2: 43.5388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_465_5390",
    x1: 67.5312,
    y1: 57.5206,
    x2: 167.531,
    y2: -133.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_5390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.621582)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_465_5390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.621582)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_465_5390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.254395)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategoryPancakes);
export default __webpack_public_path__ + "static/media/icon-category-pancakes.312fef35.svg";
export { ForwardRef as ReactComponent };